import { RestfulRevenueSharingWebService, RevenueSharingWebService } from 'ws/RevenueSharingWebService';
import { CurrentRevenueSharing, RevenueSharing, RevenueSharingCreateDTO, RevenueSharingFormData } from './RevenueSharing';

export interface RevenueSharingManager {
  getRevenueSharings (): Promise<RevenueSharing[]>;
  getCurrentRevenueSharings (): Promise<CurrentRevenueSharing[]>;
  createRevenueSharing (revenueSharingFormData: RevenueSharingFormData): Promise<void>;
}

export class DefaultRevenueSharingManager implements RevenueSharingManager {

  constructor (
    private revenueSharingWebService: RevenueSharingWebService = new RestfulRevenueSharingWebService()
  ) {}

  async getRevenueSharings (): Promise<RevenueSharing[]> {
    return this.revenueSharingWebService.getRevenueSharings();
  }

  async getCurrentRevenueSharings (): Promise<CurrentRevenueSharing[]> {
    return this.revenueSharingWebService.getCurrentRevenueSharings();
  }

  async createRevenueSharing (revenueSharingFormData: RevenueSharingFormData): Promise<void> {
    const { purpose, effectiveDate, isInstant, partnershipModeId, percentage } = revenueSharingFormData;
    const revenueSharingCreateDTO: RevenueSharingCreateDTO = {
      partnershipModeId,
      // 19.35 / 100 在 JS 是 0.19350000000000003，比率最多 4 位小數，送出前收斂
      percentage: Number((Number(percentage) / 100).toFixed(4)),
      purpose,
      isInstant
    };
    // 即刻生效時由後端決定「今天」，不送日期避免和後端判斷不一致
    if (!isInstant) {
      revenueSharingCreateDTO.effectiveDate = effectiveDate;
    }
    await this.revenueSharingWebService.createRevenueSharing(revenueSharingCreateDTO);
  }
}
